import { createThreadBehaviour } from './shared-responder-v2-core-thread-behaviour';
import {
  emptyTaskDraft,
  reduceTaskDraft,
} from './shared-responder-v2-core-thread-task';
import { THREAD_KINDS } from './shared-responder-v2-core-thread.consts';

/**
 * A URL question differs from a task only in surface — it shows an open-site
 * gate first — not in the answer model, so it reuses task's draft helpers
 * rather than duplicating them.
 */
export const URL_THREAD_BEHAVIOUR = createThreadBehaviour({
  kind: THREAD_KINDS.Url,
  isAnswerEditable: false,
  recordsVoiceWhenUrlPresent: false,
  emptyDraft: emptyTaskDraft,
  reduceDraft: reduceTaskDraft,
  isDraftComplete: () => true,
  showsContinueButton: () => true,
});
